import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IAppState } from '@myStore/app.state';
import { SetProbationaryForStudent } from '@myStore/students-performance/students-perfomance.actions';
import {
  DeleteStudentFinalResultFailure,
  DeleteStudentFinalResultRequest,
  DeleteStudentFinalResultSuccess,
  DeleteStudentHappyPointFailure,
  DeleteStudentHappyPointRequest,
  DeleteStudentHappyPointSuccess,
  DeleteUserFailure,
  DeleteUserRequest,
  DeleteUserSuccess,
  EditNoteAboutStudentFailure,
  EditNoteAboutStudentRequest,
  EditNoteAboutStudentSuccess,
  EditUserFailure,
  EditUserRequest,
  EditUserSuccess,
  EUsersChangesActions,
  ResetAllTakenStudentsWorksFailure,
  ResetAllTakenStudentsWorksRequest,
  ResetAllTakenStudentsWorksSuccess,
  SaveStudentFinalResultsFailure,
  SaveStudentFinalResultsRequest,
  SaveStudentFinalResultsSuccess,
  SendBlockStudentFailure,
  SendBlockStudentRequest,
  SendBlockStudentSuccess,
  SendNoteAboutStudentFailure,
  SendNoteAboutStudentRequest,
  SendNoteAboutStudentSuccess,
  SendUserUnlockFailure,
  SendUserUnlockRequest,
  SendUserUnlockSuccess,
} from '@myStore/users-changes/users-changes.actions';
import { DeleteHappyPoint } from '@myStore/users/user.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { UsersChangesService } from '@services/users-changes/users-changes.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class UsersChangesEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _usersChangesService: UsersChangesService,
    private _router: Router,
    private _toastr: ToastrService,
    private _location: Location
  ) {}

  $blockStudent = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<SendBlockStudentRequest>(
          EUsersChangesActions.SendBlockStudentRequest
        ),
        switchMap(action => {
          return this._usersChangesService.blockStudent(action.id).pipe(
            map(() => {
              this._store.dispatch(new SendBlockStudentSuccess());
              this._toastr.success('Пользователь успешно заблокирован');
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При блокировке пользователя возникла ошибка'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new SendBlockStudentFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $unlockUser = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<SendUserUnlockRequest>(
          EUsersChangesActions.SendUserUnlockRequest
        ),
        switchMap(action => {
          return this._usersChangesService.activateStudent(action.id).pipe(
            map(() => {
              this._store.dispatch(new SendUserUnlockSuccess());
              this._toastr.success('Пользователь успешно разблокирован');
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При разблокировании пользователя возникла ошибка'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new SendUserUnlockFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $addNoteAboutStudent = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<SendNoteAboutStudentRequest>(
          EUsersChangesActions.SendNoteAboutStudentRequest
        ),
        switchMap(action => {
          return this._usersChangesService
            .makeNoteAboutStudent(action.data)
            .pipe(
              map(() => {
                this._store.dispatch(new SendNoteAboutStudentSuccess());
                this._toastr.success('Заметка успешно сохранена');
              }),
              catchError(err => {
                this._toastr.error('Не получилось сохранить заметку', '', {
                  timeOut: 3500,
                });

                if (Object.keys(err.error).includes('student')) {
                  this._toastr.error(err.error.student[0], '', {
                    timeOut: 3500,
                  });
                }

                this._store.dispatch(
                  new SendNoteAboutStudentFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $editNoteAboutStudent = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<EditNoteAboutStudentRequest>(
          EUsersChangesActions.EditNoteAboutStudentRequest
        ),
        switchMap(action => {
          return this._usersChangesService
            .editNoteAboutStudent(action.id, action.data)
            .pipe(
              map(() => {
                this._store.dispatch(new EditNoteAboutStudentSuccess());

                if (!action.isEditor) {
                  this._toastr.success('Заметка успешно отредактирована');
                }
              }),
              catchError(err => {
                if (Object.keys(err.error).includes('student')) {
                  this._toastr.error(err.error.student[0], '', {
                    timeOut: 3500,
                  });
                }

                this._store.dispatch(
                  new EditNoteAboutStudentFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $resetAllTakenStudentsWorks = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<ResetAllTakenStudentsWorksRequest>(
          EUsersChangesActions.ResetAllTakenStudentsWorksRequest
        ),
        switchMap(action => {
          return this._usersChangesService
            .resetAllStudentsWorks(action.id)
            .pipe(
              map(() => {
                this._store.dispatch(new ResetAllTakenStudentsWorksSuccess());
                this._toastr.success(
                  'Взятые домашнии работы успешно сброшены.'
                );
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'Не удалось сбросить домашние работы'
                  }`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(
                  new ResetAllTakenStudentsWorksFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  delete$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteUserRequest>(EUsersChangesActions.DeleteUserRequest),
        switchMap(action => {
          return this._usersChangesService.deleteUser(action.id).pipe(
            map(() => {
              this._store.dispatch(new DeleteUserSuccess());

              if (action.options?.navTo) {
                this._router.navigate([action.options.navTo]);
              }

              this._toastr.success('Пользователь успешно удален');
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'Не удалось удалить пользователя'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new DeleteUserFailure(err));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  edit$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<EditUserRequest>(EUsersChangesActions.EditUserRequest),
        switchMap(action => {
          return this._usersChangesService
            .editUser(action.id, action.userData)
            .pipe(
              map(res => {
                this._store.dispatch(new EditUserSuccess(res.user));

                if (action.options?.message) {
                  this._toastr.success(action.options?.message);
                } else {
                  this._toastr.success(res.detail);
                }

                if (action.options?.navTo) {
                  this._router.navigate([action.options?.navTo]);
                }

                if (
                  action.userData.is_probation !== undefined &&
                  res.user.id &&
                  res.user.is_probation !== undefined
                ) {
                  this._store.dispatch(
                    new SetProbationaryForStudent(
                      res.user.id,
                      res.user.is_probation
                    )
                  );
                }
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При редактировании возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(new EditUserFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  saveFinalResults$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<SaveStudentFinalResultsRequest>(
          EUsersChangesActions.SaveStudentFinalResultsRequest
        ),
        switchMap(action => {
          return this._usersChangesService
            .saveStudentResults(action.userId, action.data)
            .pipe(
              map(() => {
                this._store.dispatch(new SaveStudentFinalResultsSuccess());
                this._toastr.success('Успеваемость сохранена успешно!');
                this._router.navigate([
                  `/users/${action.userId}/final/results/`,
                ]);
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'Не удалось сохранить успеваемость'
                  }`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(
                  new SaveStudentFinalResultsFailure(err.error)
                );
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  deleteFinalResults$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteStudentFinalResultRequest>(
          EUsersChangesActions.DeleteStudentFinalResultRequest
        ),
        switchMap(action => {
          return this._usersChangesService.deleteStudentResults(action.id).pipe(
            map(() => {
              this._store.dispatch(new DeleteStudentFinalResultSuccess());
              this._toastr.success('Успеваемость удалена!');
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'Не удалось удалить успеваемость'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(
                new DeleteStudentFinalResultFailure(err.error)
              );
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  deleteHappyPoint$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<DeleteStudentHappyPointRequest>(
          EUsersChangesActions.DeleteHappyPointRequest
        ),
        switchMap(action => {
          return this._usersChangesService
            .deleteHappyPoint(action.group, action.period, action.student)
            .pipe(
              map(() => {
                this._store.dispatch(new DeleteStudentHappyPointSuccess());
                this._store.dispatch(new DeleteHappyPoint(action.period));
                this._toastr.success('Happy Point отменён!!');
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'Не удалось отменить HP'
                  }`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(
                  new DeleteStudentHappyPointFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );
}
